// @ts-nocheck
import { Plugin } from '/home/ZCIPClient/workpath/164805/code/code/promotion-frontend/promotionh5DXP/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','locale','request',],
});

export { plugin };
